import { FBCallToAction } from '@marketing-milk/interfaces'

/**
 * Title-case a Facebook call-to-action enum value for display on the local
 * preview's CTA button, e.g. `APPLY_NOW` -> "Apply Now" — the casing Facebook's
 * own button uses, where the editors' selects show the raw uppercased value.
 */
export function formatCallToAction(cta: FBCallToAction | string): string {
  return cta
    .split('_')
    .map(word => (word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(' ')
}
